import { Button, Card, Checkbox, Form, Modal, Select, SelectProps, Spin, Table, TableProps, Typography } from 'antd';
import { FormInstance } from 'antd/lib';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import iconDelete from '../../assets/images/price-schedule/icon-delete.svg';
import iconSegment from '../../assets/images/price-schedule/icon-segment.svg';
import '../../assets/styles/desktop/busBooking.scss';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { getAllRoute, routeSelector } from '../../redux/slice/routeSlice';
import {
  getPriceScheduleSegment,
  priceScheduleSelector,
  setListSegmentActive,
  setListSegmentPriceSchedule,
} from '../../redux/slice/schdules/priceScheduleSlice';
interface DataType {
  key: string;
  route_id?: any;
  bus_type: string;
  depart_time: string;
  arrive_time: string;
  route: any;
  schedule_id: number;
  segment_amount: number;
  segments?: any;
  children?: DataType[];
}

const ModalPriceSegment: React.FC<any> = ({
  okText,
  cancelText,
  modalOpen,
  onCancel,
  onOk,
  watchRangeDate,
  isUpdate,
  isCreate,
}) => {
  const { t } = useTranslation();
  const { listAllRoute } = useAppSelector(routeSelector);
  const { listPriceSegment, listSegmentActive, loadingDetail } = useAppSelector(priceScheduleSelector);
  const [form]: [FormInstance] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(modalOpen);
  const dispatch = useAppDispatch();
  const watchRouteId = Form.useWatch('route_id', form);
  const [expandedRowKeys, setExpandedRowKeys] = useState<string[]>([]);

  const modalHandleOk = () => {
    onOk();
  };

  const modalHandleCancel = () => {
    onCancel();
    form.resetFields();
  };

  const filterOptionRoute = (
    input: string,
    option?: {
      label?: any;
      value?: any;
    },
  ) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

  const RouteOptions: SelectProps['options'] = listAllRoute?.length
    ? listAllRoute?.map((item: any) => {
        return {
          value: item.id,
          label: `${item?.depart_point} - ${item?.arrive_point}`,
        };
      })
    : [];
  const handleCheckboxChange = (checkedValues: any[], record: any, segmentOptions: any[]) => {
    const isSelectAll = checkedValues?.includes('all');
    const updatedSegments = isSelectAll
      ? segmentOptions
      : segmentOptions?.filter((option) => checkedValues?.includes(option.value));
    const finalCheckedValues = isSelectAll ? [...segmentOptions?.map((option) => option.value), 'all'] : checkedValues;
    form.setFieldsValue({ [record.schedule_id]: finalCheckedValues });
    const updatedList = listSegmentActive
      ?.filter((item: any) => item?.schedule_id !== record?.schedule_id)
      ?.concat(
        updatedSegments?.length > 0
          ? [
              {
                schedule_id: record.schedule_id,
                depart_time: record.depart_time,
                route: {
                  depart: record.route.depart,
                  arrive: record.route.arrive,
                },
                segments: updatedSegments?.map((segment) => ({
                  segment_id: segment.value,
                  start_location: segment.label.split(' - ')[0],
                  end_location: segment.label.split(' - ')[1],
                })),
              },
            ]
          : [],
      );
    dispatch(setListSegmentActive(updatedList));
  };

  const handleRemoveSegment = (segmentItem: any, segment: any) => {
    const updatedList = listSegmentActive
      ?.map((schedule: any) => {
        if (schedule?.schedule_id === segmentItem?.schedule_id) {
          const updatedSegments = schedule?.segments?.filter((s: any) => s?.segment_id !== segment?.segment_id);
          form.setFieldsValue({
            [segmentItem.schedule_id]: updatedSegments.map((s: any) => s?.segment_id),
          });

          return {
            ...schedule,
            segments: updatedSegments,
          };
        }
        return schedule;
      })
      ?.filter((schedule: any) => schedule?.segments?.length > 0);
    dispatch(setListSegmentActive(updatedList));
  };

  const columns: TableProps<DataType>['columns'] = [
    {
      title: 'Tuyến',
      dataIndex: 'route_id',
      key: 'route_id',
      width: '26%',
      render: (_, record) => <Typography>{`${record?.route?.depart} - ${record?.route?.arrive}`}</Typography>,
    },
    {
      title: 'Giờ đi',
      dataIndex: 'depart_time',
      key: 'depart_time',
      width: '14%',
      render: (text) => <Typography>{text?.slice(0, 5)}</Typography>,
      sorter: (a, b) => a?.depart_time.localeCompare(b?.depart_time),
    },
    {
      title: 'Giờ đến',
      dataIndex: 'arrive_time',
      key: 'arrive_time',
      width: '16%',
      render: (text) => <Typography>{text?.slice(0, 5)}</Typography>,
      sorter: (a, b) => a?.arrive_time.localeCompare(b?.arrive_time),
    },
    {
      title: 'Loại xe',
      dataIndex: 'bus_type',
      key: 'bus_type',
      width: '25%',
      render: (text) => <Typography>{text}</Typography>,
    },
    {
      title: '',
      key: 'actions',
      fixed: 'right',
      width: '6%',
      render: (_, record) => null,
    },
  ];

  const onFinish = (values: any) => {
    values.route_id = undefined;
    const routeValue = listSegmentActive
      ?.map((segmentItem: any) => segmentItem?.segments?.map((item: any) => item?.segment_id))
      ?.flat();
    dispatch(setListSegmentPriceSchedule(routeValue));
    onCancel();
  };

  useEffect(() => {
    setIsModalOpen(modalOpen);
  }, [modalOpen]);

  useEffect(() => {
    dispatch(getAllRoute({}));
  }, [dispatch]);

  useEffect(() => {
    if (isCreate) {
      setExpandedRowKeys([]);
    }
  }, [isCreate]);

  useEffect(() => {
    dispatch(
      getPriceScheduleSegment({
        route_id: watchRouteId,
        start_date: dayjs(watchRangeDate?.[0]).format('YYYY-MM-DD'),
        end_date: dayjs(watchRangeDate?.[1]).format('YYYY-MM-DD'),
        is_full: isUpdate ? true : false,
      }),
    );
  }, [dispatch, watchRouteId, watchRangeDate, isUpdate]);
  useEffect(() => {
    if (listSegmentActive?.length) {
      const updatedValues: Record<string, any[]> = {};
      listSegmentActive?.forEach((item: any) => {
        updatedValues[item?.schedule_id] = item?.segments?.map((seg: any) => seg?.segment_id);
      });
      form.setFieldsValue(updatedValues);
    }
  }, [listSegmentActive, form, modalOpen]);
  useEffect(() => {
    if (listSegmentActive?.length) {
      const newExpandedKeys = listSegmentActive?.map((segment: any) => String(segment?.schedule_id));
      setExpandedRowKeys(newExpandedKeys);
    }
  }, [listSegmentActive]);

  return (
    <>
      <Spin spinning={loadingDetail}>
        <Modal
          open={isModalOpen}
          onOk={modalHandleOk}
          onCancel={modalHandleCancel}
          cancelText={cancelText}
          okText={okText}
          footer={[]}
          width={1118}
          maskClosable={false}
          confirmLoading={loadingDetail}
          centered
          className="modal-bus-booking detail-schedule segment"
        >
          <Card className="card-modal-booking">
            <Form
              className="mg-16 "
              form={form}
              labelCol={{ xxl: 5, xl: 6, lg: 7, md: 24, sm: 24 }}
              requiredMark={false}
              colon={false}
              onFinish={onFinish}
              initialValues={{
                route_id: '',
              }}
            >
              <div className="d-flex price-schedule-block">
                <div className="side-price-schedule-left">
                  <p className="fs-18 fw-600 title">Chọn chặng áp dụng</p>
                  <Form.Item name="route_id" className="mt-3">
                    <Select
                      className="input-h38 province"
                      showSearch
                      filterOption={filterOptionRoute}
                      placeholder="Chọn tuyến đường"
                      size="large"
                      style={{ width: '100%' }}
                      options={[{ value: '', label: 'Tất cả các tuyến' }, ...RouteOptions]}
                      defaultValue={''}
                    />
                  </Form.Item>
                  <Table<DataType>
                    locale={{
                      triggerDesc: 'Sắp xếp tăng dần',
                      triggerAsc: 'Hủy sắp xếp',
                      cancelSort: 'Sắp xếp giảm dần',
                    }}
                    dataSource={listPriceSegment?.length ? listPriceSegment : []}
                    columns={columns}
                    pagination={false}
                    rowKey={(record: any) => String(record?.schedule_id)}
                    className="table-segment-price"
                    expandable={{
                      expandedRowRender: (record: any) => {
                        const segmentOptions = record?.segments?.map((segment: any) => ({
                          label: `${segment?.start_location} - ${segment?.end_location}`,
                          value: segment?.segment_id,
                        }));
                        const allSegmentValues = segmentOptions?.map((option: any) => option.value);
                        const selectedValues = form.getFieldValue(record?.schedule_id) || [];
                        const isAllChecked = allSegmentValues?.every((val: any) => selectedValues.includes(val));
                        const isIndeterminate =
                          selectedValues.length > 0 && selectedValues.length < allSegmentValues.length;
                        return (
                          <div>
                            <Checkbox
                              indeterminate={isIndeterminate}
                              checked={isAllChecked}
                              onChange={(e) => {
                                const newCheckedValues = e.target.checked ? [...allSegmentValues, 'all'] : [];
                                handleCheckboxChange(newCheckedValues, record, segmentOptions);
                              }}
                            >
                              Chọn tất cả
                            </Checkbox>
                            <Form.Item name={`${record?.schedule_id}`} className="mt-3" valuePropName="value">
                              <Checkbox.Group
                                options={segmentOptions}
                                defaultValue={form.getFieldValue(`${record?.schedule_id}`) || []}
                                onChange={(checkedValues) =>
                                  handleCheckboxChange(checkedValues, record, segmentOptions)
                                }
                              />
                            </Form.Item>
                          </div>
                        );
                      },
                      onExpand: (expanded, record) => {
                        setExpandedRowKeys((prevKeys: any) =>
                          expanded
                            ? [...prevKeys, String(record?.schedule_id)]
                            : prevKeys?.filter((key: any) => key !== String(record?.schedule_id)),
                        );
                      },
                      expandIconColumnIndex: columns.length - 1,
                      expandedRowKeys: expandedRowKeys,
                      expandIcon: ({ expanded, onExpand, record }) =>
                        expanded ? (
                          <Button className="btn-active" onClick={(e: any) => onExpand(record, e)}>
                            Xong
                          </Button>
                        ) : (
                          <Button className="btn-active" onClick={(e: any) => onExpand(record, e)}>
                            Chọn
                          </Button>
                        ),
                    }}
                  />
                </div>
                <div className="side-price-schedule-right relative">
                  <div className="segment-price-content-item">
                    <p className="fs-14 fw-500 text-blue total-segment">
                      Đã chọn:
                      <span className="text-success fs-14 fw-600">{` (${
                        listSegmentActive?.length
                          ? listSegmentActive?.map((segmentItem: any) => segmentItem?.segments)?.flat()?.length
                          : 0
                      })`}</span>
                    </p>
                    <div className="schedule-list-item">
                      {listSegmentActive?.map((segmentItem: any) => (
                        <div key={segmentItem?.schedule_id} className="mt-2 ">
                          <div className="gap-x-8 d-flex items-center">
                            <img src={iconSegment} alt="" className="mt-1" />
                            <p className="fs-14 fw-600 text-black mt-1">
                              {`${segmentItem?.route?.depart} - ${
                                segmentItem?.route?.arrive
                              } (${segmentItem?.depart_time?.slice(0, 5)})`}
                            </p>
                          </div>
                          <div className="segment-block-item">
                            {segmentItem?.segments?.length
                              ? segmentItem?.segments?.map((segment: any, index: number) => (
                                  <div key={index} className="d-flex items-center justify-between  mt-2">
                                    <p className="fs-14 fw-500 label-segment">{`${segment?.start_location} - ${segment?.end_location}`}</p>
                                    <button
                                      onClick={() => handleRemoveSegment(segmentItem, segment)}
                                      className="border-none bg-transparent"
                                      type="button"
                                    >
                                      <img src={iconDelete} alt="" className="cursor-pointer" />
                                    </button>
                                  </div>
                                ))
                              : ''}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="d-flex items-center gap-x-8 absolute btn-group-segment">
                    <Button
                      key="cancel"
                      className="w-150 h-btn-44 btn-back fs-16 fw-600 t-b rounded-lg"
                      // loading={loading}
                      htmlType="button"
                      onClick={() => modalHandleCancel()}
                    >
                      Đóng
                    </Button>
                    <Button
                      key="submit"
                      className=" w-150 h-btn-44 btn-success text-white fs-16 fw-600 rounded-lg mr-8"
                      htmlType="submit"
                      onClick={() => modalHandleOk()}
                    >
                      Lưu
                    </Button>
                  </div>
                </div>
              </div>
            </Form>
          </Card>
        </Modal>
      </Spin>
    </>
  );
};
export default ModalPriceSegment;
